import { FONT, C } from "../lib/programConstants";

const GOAL_ICONS = {
  "Build Muscle": "💪",
  "Lose Weight": "🔥",
  "Improve fitness": "🏃",
  "Get Stronger": "🏋️",
};

const MODE_LABELS = {
  pinned: "Fixed Schedule",
  flexible: "Flexible",
  rolling: "Rolling",
};

export default function ProgramSelectorStep({ programs = [], onSelectProgram, onLogout }) {
  return (
    <div style={{ minHeight: "100vh", background: C.bg, fontFamily: FONT, maxWidth: 480, margin: "0 auto" }}>
      <style>{`
        @keyframes fadeIn { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }
        @keyframes slideUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
        * { box-sizing:border-box; margin:0; padding:0; }
      `}</style>

      <div style={{ padding: "48px 20px 24px", background: C.dark, color: "#fff", animation: "fadeIn 0.5s ease", position: "relative" }}>
        {onLogout && (
          <button onClick={onLogout} title="Logout" style={{
            position: "absolute", top: 16, right: 16, background: "rgba(255,255,255,0.1)",
            border: "none", borderRadius: 8, padding: "8px", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 17L21 12L16 7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 12H9" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
        <div style={{ fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>
          Your Programs
        </div>
        <div style={{ fontSize: 26, fontWeight: 800, lineHeight: 1.2, marginBottom: 4 }}>
          Choose a Program
        </div>
        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.45)" }}>
          {programs.length} active program{programs.length !== 1 ? "s" : ""}
        </div>
      </div>

      <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: 12 }}>
        {programs.map((program, i) => (
          <button
            key={program.program_id}
            onClick={() => onSelectProgram(program)}
            style={{
              width: "100%", textAlign: "left", cursor: "pointer",
              background: "#fff", border: `1px solid ${C.borderLight}`, borderRadius: 14,
              padding: "18px", display: "flex", gap: 14, alignItems: "flex-start",
              animation: `slideUp 0.4s ease ${0.1 + i * 0.08}s both`,
              transition: "box-shadow 0.15s ease, border-color 0.15s ease",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.06)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.borderLight; e.currentTarget.style.boxShadow = "none"; }}
          >
            <div style={{
              width: 44, height: 44, borderRadius: 12, background: C.dark, flexShrink: 0,
              display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20,
            }}>
              {GOAL_ICONS[program.goal] || "🏋️"}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 3, fontFamily: FONT }}>
                {program.name}
              </div>
              {program.description && (
                <div style={{ fontSize: 12, color: C.sub, marginBottom: 6, lineHeight: 1.4 }}>
                  {program.description}
                </div>
              )}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {program.goal && (
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 5, background: C.chip, border: `1px solid ${C.borderLight}`, color: C.sub, fontWeight: 500 }}>
                    {program.goal}
                  </span>
                )}
                {program.bounded_weeks && (
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 5, background: C.chip, border: `1px solid ${C.borderLight}`, color: C.sub, fontWeight: 500 }}>
                    {program.bounded_weeks} weeks
                  </span>
                )}
                {program.scheduling_mode && (
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 5, background: C.chip, border: `1px solid ${C.borderLight}`, color: C.sub, fontWeight: 500 }}>
                    {MODE_LABELS[program.scheduling_mode] || program.scheduling_mode}
                  </span>
                )}
              </div>
            </div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, marginTop: 4 }}>
              <path d="M6 4L10 8L6 12" stroke={C.muted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        ))}
      </div>

      <div style={{ height: 48 }} />
    </div>
  );
}
